
export default {
  name: 'EnerLoader',
  props: {
    height: {
      type: String,
      default: '500px'
    },
    width: {
      type: String,
      default: '100%'
    },
    maxWidth: {
      type: String,
      default: '1200px'
    },
    color: {
      type: String,
      default: '#EC6625'
    },
    backgroundColor: {
      type: String,
      default: '#00758F'
    },
    backgroundOpacity: {
      type: Number,
      default: 0.5
    }
  },
  data () {
    return {
      computedStyle: {
        height: this.height,
        width: this.width,
        'max-width': this.maxWidth,
        margin: '0 auto'
      }
    }
  }
}
